import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusDevelopmentStatus, deleteDevelopmentStatus, getAllDevelopmentStates } from "../../../../api/developmentStatus";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";
import { buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";

export default function TechnologyPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [developmentStatus, setDevelopmentStatus] = useState(null);

    useEffect(() => {
        getAllDevelopmentStates()
            .then((res) => {
                const data = res.data.map(item => ({
                    ...item,
                    title: getNonEmpty(item.title),
                    description: getNonEmpty(item.description),
                    id: item._id,
                }))
                setData(data);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get development status.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisableDelete(cell, "developmentStatus", data, user?.role === "admin", setDevelopmentStatus, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Development states list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-developmentStatus")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={`Are you sure you want to ${developmentStatus?.active ? "deactivate" : "activate"} this development status?`}
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            changeStatusDevelopmentStatus(developmentStatus.id, !developmentStatus?.active)
                                .then((res) => {
                                    alertSuccess({
                                        title: `${developmentStatus?.active ? "Deactivate!" : "Activate!"
                                            }`,
                                        customMessage: `Development status ${developmentStatus?.active ? "deactivate" : "activate"
                                            } successfully`,
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: `Could not ${developmentStatus?.active ? "deactivate" : "activate"
                                            } the development status.`,
                                    });
                                });
                        }}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this development status?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteDevelopmentStatus(developmentStatus.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Development status deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the development status.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}